var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-0",attrs:{"tile":"","flat":"","width":"100%"}},[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{staticClass:"pt-0 pb-0 pl-0 pr-0 pr-md-1",attrs:{"cols":"12","md":"6"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }